const WorkerFactory = (workerFunction: () => void): Worker => {
  const workerBlob = new Blob([`(${workerFunction.toString()})()`], {
    type: "module",
  });

  return new Worker(URL.createObjectURL(workerBlob));
};

export default WorkerFactory;
